$(document).ready(function () {
    $('.order_note').click(function () {
        $('.cartNoteModal').addClass('open');
    });
    $('.savebutton').click(function () {
        $('.cartNoteModal').removeClass('open');
        const textValue = $('#CartNote').val();
        console.log('textValue', textValue);
        if (textValue) {
            $('.textchange').text('Edit to');
        } else {
            $('.textchange').text('Click to Add');
        }
    });
    $('.close_btn').click(function () {
        $('.cartNoteModal').removeClass('open');
    });
});